/** База API: пустая строка = относительный путь (Vite proxy `/api` в dev). */
export function getApiBase(): string {
  const raw = (import.meta.env.VITE_API_BASE as string | undefined)?.trim() ?? '';
  return raw.replace(/\/$/, '');
}
